<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      @keydown.enter="generateInfoBL"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.vessel"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">NOTA PENAGIHAN BIAYA PENGIRIMAN BARANG</h2>
          <h3 class="text-center">{{ companyName }}</h3>
        </div>
        <div class="right ml-5">
          <table>
            <tr>
              <td>Nomor Nota</td>
              <td>:</td>
              <td class="border">32112</td>
            </tr>
            <tr>
              <td>Kode Nota</td>
              <td>:</td>
              <td class="border-dotted">P</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="mt-4">
        <div class="invoice-info">
          <h3 class="mb-0 font-italic">Ditagih Kepada:</h3>
          <h3 class="mb-0 font-italic">Nama Kapal:</h3>
        </div>

        <div class="items mt-3">
          <p>Keterangan Pengiriman:</p>

          <table>
            <thead>
              <th>KodeTTB</th>
              <th>Kondisi</th>
              <th>Dikirim Kepada</th>
              <th>Koli</th>
              <th>Cargo</th>
            </thead>
          </table>

          <div class="price"></div>
        </div>

        <!-- <div class="port mt-2" v-for="serve in port.serve" :key="serve.id">
          <div>
            <div class="head">
              <p class="tos font-italic">Service Cabang: <b>{{ serve.tos }}</b></p>
            </div>
            <table width="100%" class="border-bottom">
              <thead>
                <td class="text-left font-italic">No Container</td>
                <td class="font-italic text-center"></td>
                <td width="40%" class="font-italic">TTB</td>
                <td class="font-italic">Cargo</td>
              </thead>
              <tbody>
                <tr v-for="container in serve.containers" :key="container.id">
                  <td><b>{{ container.prioritas_berangkat }}</b> {{ container.no_container }} / {{ container.no_seal }} (KC: {{ container.kc }})</td>
                  <td>
                    <template v-if="container.cargo != 'campuran' && container.cargo != 'campuran'">
                      <div>
                        <p class="mb-0" v-for="contDetil in container.container_detil" :key="contDetil.id">{{ contDetil.ttb.kondisi_detil.kondisi }}</p>
                      </div>
                    </template>
                  </td>
                  <td>
                    <template v-if="container.cargo != 'campuran' && container.cargo != 'campuran'">
                      <div>
                        <p class="mb-0" v-for="contDetil2 in container.container_detil" :key="contDetil2.id">{{ contDetil2.ttb.nottb }} - <span v-if="contDetil2.ttb.penerima_detil">{{ contDetil2.ttb.penerima_detil.badan_usaha }}</span> <span v-if="contDetil2.ttb.penerima_detil">{{ contDetil2.ttb.penerima_detil.nama }}</span></p>
                      </div>
                    </template>
                  </td>
                  <td>{{ container.cargo }}</td>
                </tr>
              </tbody>
            </table>
            <p class="total-cont text-right font-italic">Total Container: {{ serve.containers.length }}</p>
          </div>
        </div> -->
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      formData: {
        kv: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async generateInfoBL() {
      this.state.loading = true;

      await axios
        .get(`laporan/masterlis-vessel?kv=${this.formData.kv}`)
        .then(res => {
          if (!res.data.vessel) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.header .left {
  border: 1px solid black;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}
</style>
